// Biteship COD (Phase 2) — helper murni checkout. Eligibility, fee, dan total COD berasal dari server
// (/payment-methods flag tenant + flag rate Biteship + /shipping/cod-quote); tidak ada tabel fee/kurir lokal.
export const COD_METHOD = "biteship_cod";

export const codOptionVisible = ({ paymentInfo, providerUsed, selectedRate }) =>
  !!(paymentInfo?.biteship_cod?.available && providerUsed === "biteship"
    && selectedRate?.rate_quote_id && selectedRate?.available_for_cash_on_delivery);

// Kunci dependensi quote COD: pilihan kurir/layanan, alamat, isi cart, voucher. Berubah → quote lama stale.
export const codQuoteKey = ({ selectedRate, addressId, items, voucherCode }) =>
  [selectedRate?.rate_quote_id || "", addressId || "", (items || []).map((i) => `${i.id}:${i.quantity}`).join(","), voucherCode || ""].join("|");

export const checkoutSummary = ({ cartTotal, shippingCost, discount, payment, codQuote }) => {
  const base = Math.max(0, cartTotal + shippingCost - discount);
  if (payment === COD_METHOD && codQuote) {
    return { base, codFee: codQuote.cod_fee, total: codQuote.cod_total, isCod: true, mismatch: Math.round(base) !== codQuote.base_amount };
  }
  return { base, codFee: 0, total: base, isCod: false, mismatch: false };
};
